import { apiRequest } from '@/api/client';
import type { ConfirmPurchaseRequest, DomainPurchaseView, DomainPurchasesOverview, StartPurchaseRequest } from '@/types/api';

/** Buying domains through 2d2s (ADR-0039): check first, pay only on confirmation. */
export const domainPurchasesApi = {
  overview: () => apiRequest<DomainPurchasesOverview>('/domain-purchases'),

  get: (id: string) => apiRequest<DomainPurchaseView>(`/domain-purchases/${id}`),

  /** Asks 2d2s which names are free. Pays for nothing. */
  start: (input: StartPurchaseRequest) => apiRequest<DomainPurchaseView>('/domain-purchases', { method: 'POST', body: input }),

  /** Buys the chosen free names: the one call that spends money. */
  confirm: (id: string, input: ConfirmPurchaseRequest) =>
    apiRequest<DomainPurchaseView>(`/domain-purchases/${id}/confirm`, { method: 'POST', body: input }),

  cancel: (id: string) => apiRequest<DomainPurchaseView>(`/domain-purchases/${id}/cancel`, { method: 'POST', body: {} }),
};
